import React from 'react';
import { ShopView } from './ShopView';
import { NpcTitleBlock } from './NpcPanelChrome';
import type { ShopItem } from '../../types/ShopItem';
import type { CharacterClass } from '../../../../shared/CharacterTypes';
import { NPC_UI_VARS } from './npcPresentation';
import { TomeButton, TomePanel } from '../../primitives/tome';
import { npcTomeVibe } from './npcTomeVibe';
import './NPCPlayerUI.css';

interface VendorWindowProps {
  npcId?: string;
  npcName: string;
  items: ShopItem[];
  playerGold: number;
  viewerLevel?: number;
  viewerClass?: CharacterClass;
  pendingItemId?: string | null;
  purchaseRefusal?: { itemId: string; message: string } | null;
  onPurchase: (item: ShopItem, quantity: number) => void;
  onClose: () => void;
  onViewQuests?: () => void;
  questCount?: number;
}

/** The existing shop owner keeps NPC identity and confirmed transaction state. */
export const VendorWindow: React.FC<VendorWindowProps> = ({
  npcId, npcName, items, playerGold, viewerLevel, viewerClass, pendingItemId, purchaseRefusal,
  onPurchase, onClose, onViewQuests, questCount,
}) => {
  const npc = { id: npcId, name: npcName, type: 'shop', shopItems: items } as unknown as Parameters<typeof ShopView>[0]['npc'];
  const hasQuests = Boolean(onViewQuests && questCount && questCount > 0);
  const toolbar = hasQuests ? (
    <nav className="npc-panel-actions" aria-label="NPC navigation">
      <TomeButton tone="secondary" onClick={onViewQuests} data-controller-return="quests">
        View Quests ({questCount})
      </TomeButton>
      <TomeButton tone="primary" aria-pressed="true" disabled>
        Browse Shop ({items.length})
      </TomeButton>
    </nav>
  ) : undefined;

  return <TomePanel className="npc-player-panel npc-vendor-panel" role="dialog" shapeSeed={`${npcId}:shop`} vibe={npcTomeVibe(npcId ?? '')}
    aria-label={`${npcName} shop`} data-controller-surface="npc-shop" style={{ ...NPC_UI_VARS, zIndex: 210 }}
    header={<NpcTitleBlock npcId={npcId} npcType="shop" name={npcName} subtitle="Merchant" onClose={onClose} closeLabel="Close shop" />}
    toolbar={toolbar}>
    <ShopView npc={npc} playerGold={playerGold} viewerLevel={viewerLevel} viewerClass={viewerClass}
      pendingItemId={pendingItemId} purchaseRefusal={purchaseRefusal}
      onShopPurchase={onPurchase as (item: unknown, quantity: number) => void} />
  </TomePanel>;
};
